import { Flex, Text, Tooltip } from '@mantine/core';
import React from 'react';
import * as Unicons from '@iconscout/react-unicons';

interface CourseQuotaProps {
  quota: number;
}

const CourseQuota: React.FC<CourseQuotaProps> = ({ quota }) => {
  return (
    <Tooltip label={quota.toLocaleString('id-ID') + ' Available Quota'}>
      <Flex gap={4} align={'center'}>
        <Unicons.UilUsersAlt size="14" />
        <Text fz={13} fw={700}>
          {quota.toLocaleString('id-ID')}
        </Text>
      </Flex>
    </Tooltip>
  );
};

export default CourseQuota;
